import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-pt-0 tw-p-10 tw-flex tw-flex-col tw-gap-[15px]" }
const _hoisted_2 = { class: "tw-text-[25px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]" }
const _hoisted_5 = { class: "tw-text-[#231F20]" }
const _hoisted_6 = { class: "button_save" }

import ModalHeader from "@/components/common/modalHeader.vue";
import { ref, watch } from "vue";
import ModalComponent from "../common/modalComponent.vue";
import EventEmitter from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'resendTokenModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  "update:show",
  "update:only",
  "update:resend",
  "update:close",
],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);


const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:close");
};

const handleResendToken = () => {
  emit("update:resend");
  handleCloseModal();
};

const handleUpdateOnly = () => {
  emit("update:only");
  handleCloseModal();
};

const classModal = {
  background: "rgb(0, 0, 0, 0.5)",
  "border-radius": "6px",
};

const styleClassContain = {
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 38,
    "style-class": classModal,
    "style-class-contain": styleClassContain
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": `no__header`,
        style: {"z-index":"10"},
        title: "",
        onClose: handleCloseModal
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-settings-org-resend-token-modal-title-1")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-org-resend-token-description-title-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(_component_b_button, {
              style: {"line-height":"90%","border":"2px solid","height":"39px"},
              variant: "primary",
              class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
              type: "submit",
              onClick: handleUpdateOnly
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-settings-org-resend-token-button-title-update-only-1",
              )), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_b_button, {
              style: {"line-height":"90%","height":"39px"},
              variant: "primary",
              class: "tw-w-fit tw-shadow-none tw-bg-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
              type: "submit",
              onClick: handleResendToken
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-settings-org-resend-token-modal-title-1")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})